<template>
  <el-card class="community-selector">
    <div class="treeview attendance-staff">
      <ul class="community-list">
        <li 
          v-for="(item, index) in communityList" 
          :key="index" 
          @click="selectCommunity(item)"
          :class="{'selected': selectedCommunityId === item.communityId}">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'

export default {
  name: 'SelectAdminCommunity',
  props: {
    allowAll: {
      type: Boolean,
      default: true
    },
    communityOptions: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      communityList: [],
      selectedCommunityId: ''
    }
  },
  watch: {
    communityOptions: {
      immediate: true,
      handler(communities) {
        if (Array.isArray(communities)) {
          this.applyCommunities(communities)
        }
      }
    }
  },
  created() {
    if (!Array.isArray(this.communityOptions)) {
      this.loadCommunities()
    }
  },
  methods: {
    loadCommunities() {
      const params = {
        page: 1,
        row: 100
      }
      
      listAdminCommunitys(params).then(res => {
        this.applyCommunities(res.data || [])
      }).catch(() => {
        this.$message.error(this.$t('adminOwner.fetchCommunityError'))
      })
    },
    applyCommunities(communities) {
      const options = communities.slice()
      this.communityList = this.allowAll
        ? [{ name: this.$t('adminOwner.all'), communityId: '' }, ...options]
        : options
      if (!options.some(item => item.communityId === this.selectedCommunityId)) {
        this.selectedCommunityId = ''
      }
      if (!this.allowAll && options.length === 1) {
        this.selectCommunity(options[0])
      }
    },
    selectCommunity(community) {
      this.selectedCommunityId = community.communityId
      this.$emit('changeCommunity', community)
    }
  }
}
</script>

<style lang="scss" scoped>
.community-selector {
  max-height: 80vh;
  overflow-y: auto;
  .community-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s;
      color: #606060;
      font-size: 14px;
      
      &:hover {
        background-color: #f5f7fa;
      }
      
      &.selected {
        background-color: #409EFF;
        color: white;
      }
    }
  }
}
</style>
